import { isBrowser } from './environment'

const PCLN_DATA = (() => {
  let pclnData = {}

  if (isBrowser()) {
    pclnData = window.PCLN_BOOTSTRAP_DATA || window.requestHandlerData || {}
  } else {
    pclnData = {
      appName: '',
      appVersion: '-.-.-',
      node: true,
    }
  }

  return pclnData
})()

export default function () {
  return { ...PCLN_DATA }
}

export function updatePCLNData(data) {
  if (typeof data !== 'object') return

  return { ...PCLN_DATA, ...data }
}
